import { ReactElement } from 'react';
import { ProductData } from '@client/product/components/ProductData/ProductData';
import { SimilarProducts } from '@client/product/components/ProductData/SimilarProducts';
import { ProductDetails } from '@client/product/components/ProductDetails/ProductDetails';
import { ProductGallery } from '@client/product/components/ProductGallery';
import { ProductFullType } from '@client/product/redux/products/full/types';
import { Column } from '@lib/components/PrimaryLayout/Column';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import './Content.scss';

interface Props {
  product: ProductFullType;
  onAddToCart: (sku: string) => void;
}

export const Content = ({ product, onAddToCart }: Props): ReactElement => {
  const t = useTranslate();
  const { description, packaging, manufacturer, sku, settings } = product;
  const { title } = description;
  const { name, logo } = manufacturer;

  return (
    <>
      <Column
        left={(
          <div className='ProductGallery-Wrapper'>
            <ProductGallery
              manufacturerLogo={logo}
              manufacturerName={name}
              sku={sku}
              productName={title}
              imageDisclaimer={settings.imageDisclaimer ? t('Image for illustration purposes only. Actual product may differ') : undefined}
            />
          </div>
        )}
        right={(
          <div className='ProductData-Wrapper'>
            <ProductData
              product={product}
              onAddToCart={onAddToCart}
            />
          </div>
        )}
        className='ProductPage-MainSection'
      />

      <section className='ProductContent'>
        <ProductDetails
          sku={sku}
          packaging={packaging}
          description={product.description}
          isInkFinderLinkDisplayed={false}
        />
      </section>

      <section>
        <SimilarProducts />
      </section>
    </>
  );
};
